import { toast } from 'react-toastify'

/**
 * Link público que o consultor envia ao aluno. O Id da condição especial é o
 * próprio token do link.
 *
 * A rota `/condicao-especial/:id` ainda não existe no portal — é a tela pública
 * do aluno, que aguarda o design. O link já é montado no formato final para
 * não precisar mudar depois.
 */
export const montarLinkDoAluno = (id: string): string =>
  `${process.env.REACT_APP_URL}/condicao-especial/${id}`

/**
 * Copia o link para a área de transferência. `navigator.clipboard` exige
 * contexto seguro (https ou localhost); em HTTP puro caímos no fallback com
 * textarea + execCommand.
 */
export const copiarLinkDoAluno = async (id: string): Promise<void> => {
  const link = montarLinkDoAluno(id)

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(link)
    } else {
      const campo = document.createElement('textarea')
      campo.value = link
      campo.style.position = 'fixed'
      campo.style.opacity = '0'
      document.body.appendChild(campo)
      campo.select()
      document.execCommand('copy')
      document.body.removeChild(campo)
    }

    toast('Link copiado para a área de transferência.', { type: 'success' })
  } catch {
    toast(`Não foi possível copiar. O link é: ${link}`, { type: 'info' })
  }
}
